import { Component } from '@angular/core';

@Component({
  selector: 'app-random-images',
  templateUrl: './random-images.component.html',
  styleUrls: ['./random-images.component.scss'],
})
export class SessionModulesRandomImagesComponent {}
